import { render, staticRenderFns } from "./OrganicStructurePgHeader.vue?vue&type=template&id=fbc11630&scoped=true&"
import script from "./OrganicStructurePgHeader.vue?vue&type=script&lang=js&"
export * from "./OrganicStructurePgHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrganicStructurePgHeader.vue?vue&type=style&index=0&id=fbc11630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc11630",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
